import { render } from "./WrapWithArrow.vue?vue&type=template&id=11436dfc"
import script from "./WrapWithArrow.vue?vue&type=script&lang=js"
export * from "./WrapWithArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__